module.exports = __webpack_public_path__ + "static/media/icon_app_agent.089cfc14.png";